import { createReducer } from '@reduxjs/toolkit';
import { authApi } from 'services/auth';

const initialState = {
  latest_notification: null,
}

const latestNotificationReducer = createReducer(initialState, (builder) => {
  builder
    .addMatcher(authApi.endpoints.getLatestCompanyNotification.matchFulfilled, (state, action) => {
      state.latest_notification = action.payload;
    })
})

export default latestNotificationReducer;
